module.exports = __webpack_public_path__ + "img/office-rfm.95510648.png";